export default __webpack_public_path__ + "7ad8dddeb9a38f7a9f649375c4a16508.svg";